import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule, DxToastModule} from 'devextreme-angular';
import {CtlIkaPersonelAramaComponent} from './ctl-ika-personel-arama/ctl-ika-personel-arama.component';
import {IkaPersonelService} from './ctl-ika-personel.service';
import {CommonModule, DatePipe} from '@angular/common';
import {CtlSablonComponent} from '../ctl-sablon/ctl-sablon.component';
import {LabelMode} from 'devextreme/common';
import {UtilsService} from '../../../services/utils.service';
import {OrtakService} from '../../../services/ortak.service';
import {DkGlobalUserSettingsService} from '../../../services/dk-global-user-settings.service';
import {ControlConditionModel} from "../../../models/gen-control.model";
import { IkaGUI_PersonelIzin_Request } from '../../../models/ortak.dtos';
import { formatDate } from 'devextreme/localization';
@Component({
  selector: 'dk-ctl-ika-personel',
  standalone: true,
  imports: [DxTextBoxModule,
    DxButtonModule,
    CtlIkaPersonelAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxToastModule,
    CtlSablonComponent,
  ],
  providers: [IkaPersonelService],
  templateUrl: './ctl-ika-personel.component.html',
  styleUrls: ['./ctl-ika-personel.component.scss'],
})
export class CtlIkaPersonelComponent implements OnInit, OnChanges {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() notFoundText = "Kişi bulunamadı!";
  @Input() labelMode: LabelMode = this.globalSettings.globalLabelMode;
  @Input() isActivePersonel = true;
  /**
   * DKM-5232 Clara: true ise yalniz "Personel Arama" penceresi calisan (AktifEh=E, CikisTarih bos)
   * personeli listeler; koda gore cozumleme isActivePersonel'e gore kalir. Boylece sonradan ayrilmis
   * personelin yazili oldugu eski kayitlar acilinca alan bosalmaz. Varsayilan false: diger kullanimlar etkilenmez.
   */
  @Input() aramadaYalnizAktif = false;
  /**
   * DKM-5483 Cedric: true ise kullanicinin kutuya ELLE yazdigi kod da arama penceresiyle ayni aktiflik
   * suzgecinden gecer (AktifEh=E + customQuery'deki AktifTarih; customQuery yoksa bugun). Pasif personelde
   * aktifDegilText uyarisi verilir ve alan temizlenir. Kayit acilirken [code] ile programatik cozumlenen kod
   * (ctl-sablon isUserInput=false) bu kontrole girmez; ayrilmis personelin yazili oldugu eski kayitlar bozulmaz.
   * Varsayilan false: diger kullanimlar etkilenmez.
   */
  @Input() elleYazilandaYalnizAktif = false;
  @Input() aktifDegilText = "Personel aktif değil!";
  @Input() isActiveDate = "";
  @Input() rolAd = "";
  @Input() codeField = "";
  @Input() codeFieldDesc = "";
  @Input() validationRulesMap: any[] = [];
  @Input() validationV2 = false;
  public crudPopupVisible = false;
  public title!: string;
  public isFirst = true;
  public control!: any;
  controlName = "vIkaPersonel";
  @Input() isReadOnly = false;
  public data: any;
  @Input() code: any;
  @Input() type = "string";
  @Input() conditionColName: any;
  @Input() conditionColText: any;
  @Input() controlCondition: ControlConditionModel[];
  @Input() notContain = false;
  @Input() key!: string;
  @Input() isToastShown = false;
  @Input() isBindCheck = false;
  @Input() izinKontrolTarih:string = formatDate(new Date(), 'yyyy-MM-dd');
  @Input() customQuery:string = "";
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  private lastRequestId = 0;

  constructor(private service: IkaPersonelService, private utilsService: UtilsService, private ortakService: OrtakService,
              private globalSettings: DkGlobalUserSettingsService
  ) {
  }
  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    // DKM-5232 Clara: eski hâli — arama penceresinin aktiflik süzgeci yalnız isActivePersonel'den geliyordu.
    // this.service.setParams(this.isActivePersonel, this.isActiveDate, this.rolAd, this.controlCondition,this.customQuery,this.isReadOnly, this.isBindCheck)
    this.service.setParams(this.isActivePersonel || this.aramadaYalnizAktif, this.isActiveDate, this.rolAd, this.controlCondition,this.customQuery,this.isReadOnly, this.isBindCheck)
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rolAd'] || changes['isReadOnly'] || changes['isBindCheck'] || changes['customQuery']) {
      // DKM-5232 Clara: eski hâli
      // this.service.setParams(this.isActivePersonel, this.isActiveDate, this.rolAd, this.controlCondition,this.customQuery,this.isReadOnly, this.isBindCheck)
      this.service.setParams(this.isActivePersonel || this.aramadaYalnizAktif, this.isActiveDate, this.rolAd, this.controlCondition,this.customQuery,this.isReadOnly, this.isBindCheck)
    }
    if(changes['izinKontrolTarih'] && changes['izinKontrolTarih'].isFirstChange() == false){
      if(this.code ){
        this.checkPersonelIzinli();
      }
    }
  }
  getControl() {
    this.ortakService.getControl(this.controlName)
      .subscribe((data) => {
        this.control = data?.controlMetadata;
        //this.service.getDlist(this.control?.dlistCode);
        this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
        //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if (data?.controlMetadata.dlistMetadata.baseEntity) {
          if (this.labelText === "") this.labelText = this.control.controlDescription;
          if (this.code && this.control) this.getData(this.code,true)
          if (this.isFirst) this.isFirst = false;
        }
      });
  }
  searchClick() {
    this.crudPopupVisible = true
  }
  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.warningMessage = null
    this.dataResult.emit(null);
  }
  handleValueChange(e: any) {
    if (e === '' || e === null || e === undefined) this.clear();
    // DKM-5483 Cedric: eski hâli — else if (!this.isFirst) this.getData(e);
    // Bayrak senkron okunuyor (ctl-gen-kisi ile ayni desen): klavyeden mi yazildi, [code] baglamasindan mi geldi.
    else if (!this.isFirst) this.getData(e, false, this.ctlSablonComponent?.isUserInput === true);
    this.isFirst = false;
  }
  // DKM-5483 Cedric: eski hâli — getData(code: string, isSetData?: boolean) {
  getData(code: string, isSetData?: boolean, kullaniciGirdisi = false) {
    const requestId = ++this.lastRequestId;
    // DKM-5483 Cedric: elle yazilan kodda aktiflik suzgeci (yalniz isActivePersonel zaten kapaliyken anlamli).
    const aktifDogrula = kullaniciGirdisi && !isSetData && this.elleYazilandaYalnizAktif && !this.isActivePersonel;

    // DKM-5483 Cedric: eski hâli
    // this.data = this.service.getData(Number(code), this.control, this.isActivePersonel, this.isActiveDate, this.rolAd, this.control.dlistMetadata.baseEntity,this.customQuery, isSetData);
    this.data = this.service.getData(Number(code), this.control, this.isActivePersonel || aktifDogrula, this.isActiveDate, this.rolAd, this.control.dlistMetadata.baseEntity,this.customQuery, isSetData);
    this.data.load().done(async (result: any) => {
      if (requestId !== this.lastRequestId){
        return;
      } 
      if (result.length > 0) {
        this.title = result[0].AdSoyad;
        this.code = result[0][this.codeField?this.codeField:this.control.kodField];
        await this.checkPersonelIzinli();
        // Gönen havale: izin kontrolü beklenirken yeni bir kod girildiyse eski sonucu emit etme
        if (requestId !== this.lastRequestId) return;
        this.dataResult.emit(result[0]);
      } else if (aktifDogrula) {
        // DKM-5483 Cedric: aktif sorguda yok — kayit hic yok mu, yoksa pasif mi? Eski (suzgecsiz) sorguyla ayirt et.
        const pasifMi = await this.personelKayitliMi(code, isSetData);
        if (requestId !== this.lastRequestId) return;
        if (!this.isToastShown) {
          if (pasifMi) this.utilsService.showWarning(this.aktifDegilText);
          else this.utilsService.showError(this.notFoundText);
        }
        this.clear();
      } else {
        if (!this.isToastShown) {
          this.utilsService.showError(this.notFoundText);
        }
        this.clear();
      }
    });
  }
  /** DKM-5483 Cedric: kod aktiflik suzgeci olmadan (eski cozumleme sorgusu) bulunuyor mu? Hata olursa false. */
  private personelKayitliMi(code: string, isSetData?: boolean): Promise<boolean> {
    const ds = this.service.getData(Number(code), this.control, this.isActivePersonel, this.isActiveDate, this.rolAd, this.control.dlistMetadata.baseEntity, this.customQuery, isSetData);
    return new Promise((resolve) => {
      ds.load().done((r: any) => resolve(r?.length > 0)).fail(() => resolve(false));
    });
  }
  async closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      // Gönen EBYS havale ("İşlem Yapılacak Personel Bilgisi eksik"): kodun kutuya yazılması dk-ctl-sablon'da
      // handleValueChange → getData() tetikliyor ve getData this.data'yı DataSource ile eziyor. İzin kontrolü
      // beklenirken bu olursa satır yerine DataSource emit ediliyordu (Kod=undefined → form null gönderiyordu).
      // Seçilen satırı yerel değişkende tutup onu emit ediyoruz.
      const secilen = result.data;
      this.data = secilen;
      this.code = secilen[this.codeField?this.codeField:this.control.kodField];
      await this.checkPersonelIzinli();
      // Gönen havale eski hâli
      // this.dataResult.emit(this.data);
      this.dataResult.emit(secilen);
    }
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }

  async checkPersonelIzinli(){
    const request: IkaGUI_PersonelIzin_Request = new IkaGUI_PersonelIzin_Request({});
        request.personelKod = this.code;
        request.kontrolTarih = this.izinKontrolTarih;
        const res = await this.ortakService.IkaGUI_PersonelIzin_Request(request)
        if(res?.response?.result){
          this.warningMessage = null
        }
        else{
            this.warningMessage = "Personel İzinli"
        }
  }
}

